<template>
  <div class="view pa24">
    <el-dialog title="新增" width="1200px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="close">
      <el-form ref="elForm" :model="ruleForm" :rules="rules" label-width="120px" :inline="true">
        <el-form-item label="订单编号：" prop="excleCode">
          <el-input v-model="ruleForm.excleCode" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="名称：" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="计划下达日期：" prop="scheduleDate">
          <el-date-picker v-model="ruleForm.scheduleDate" type="date" placeholder="计划下达日期" value-format="yyyy-MM-dd"
            class="mb10 ml10" style="width: 240px"></el-date-picker>
        </el-form-item>
        <el-form-item label="序号：" prop="serial">
          <el-input v-model="ruleForm.serial" placeholder="请输入序号"></el-input>
        </el-form-item>
        <el-form-item label="编制人：" prop="prepared">
          <el-input v-model="ruleForm.prepared" placeholder="请输入编制人"></el-input>
        </el-form-item>
        <el-form-item label="批准人：" prop="approver">
          <el-input v-model="ruleForm.approver" placeholder="请输入批准人"></el-input>
        </el-form-item>
        <el-form-item label="审批人：" prop="examined">
          <el-input v-model="ruleForm.examined" placeholder="请输入审批人"></el-input>
        </el-form-item>
        <div class="line mgb20"></div>
        <div v-for="(item, index) in ruleForm.accessories" :key="index">
          <div class="width80">
            <el-button type="primary" @click="addItem">新增</el-button>
            <el-button type="danger" v-if="index > 0" @click="deleteItem(index)">删除</el-button>
          </div>
          <el-form-item label="作业编号：" prop="homecode">
            <el-input v-model="item.homeCode" placeholder="请输入作业编号"></el-input>
          </el-form-item>
          <el-form-item label="产品类型：" :prop="`accessories[${index}].classIdAttr`"
            :rules="getItemRules(index, 'classIdAttr')">
            <el-cascader style="width: 100%" v-model="item.classIdAttr" placeholder="选择产品类型" :options="mainProducts"
              :emitPath="false" :filterable="true" :props="{
                value: 'id',
                label: 'name',
                children: 'children',
                checkStrictly: true,
              }" @change="selectItem($event, index)"></el-cascader>
          </el-form-item>
          <el-form-item label="规格：" :prop="`accessories[${index}].partNumber`">
            <el-input v-model="item.partNumber" placeholder="请输入规格"></el-input>
          </el-form-item>
          <el-form-item label="图号：" prop="drawing">
            <el-input v-model="item.drawing" placeholder="请输入图号"></el-input>
          </el-form-item>
          <el-form-item label="所需数量：" prop="num">
            <el-input v-model="item.num" placeholder="请输入所需数量"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-select v-model="item.unit" placeholder="请选择">
              <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订购单位：" prop="orderCompany">
            <el-input v-model="item.orderCompany" placeholder="请输入订购单位"></el-input>
          </el-form-item>
          <el-form-item label="合同号：" prop="contract">
            <el-input v-model="item.contract" placeholder="请输入合同号"></el-input>
          </el-form-item>
          <el-form-item label="交货期：" prop="delivery">
            <el-date-picker v-model="item.delivery" type="datetime" placeholder="计划日期" value-format="yyyy-MM-dd"
              format="yyyy-MM-dd" style="width: 202px" @change="handleDeliveryChange" editable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="item.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="是否开票：" prop="invoicing">
            <el-radio-group v-model="item.invoicing">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="销售人员：" prop="sale">
            <el-input v-model="item.sale" placeholder="请输入销售人员"></el-input>
          </el-form-item>
          <div class="line mgb20"></div>
        </div>
        <div class="dialog-footer" style="text-align: right">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" class="btncss" @click="confirm">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchClassTree } from "@/api/customPageClass.js";
  import { save, list, addBoomApi } from "@/api/boomClass.js";
  import { selectAllUnit } from '@/api/storeUnit.js'
  export default {
    name: "",
    components: {},
    props: [],
    data() {
      return {
        unitList: [],
        dialogVisible: false,
        ruleForm: {
          excleCode: "",
          name: "",
          scheduleDate: "",
          serial: "",
          prepared: "",
          approver: "",
          examined: "",
          accessories: [
            {
              homecode: "",
              name: "",
              partNumber: "",
              drawing: "",
              num: "",
              unit: "",
              orderCompany: "",
              contract: "",
              delivery: "",
              remark: "",
              invoicing: "",
              sale: "",
              supplier_name: "",
              quantities: "",
              mold: 0,
              classIdAttr: [],
            },
          ],
        },
        mainProducts: [],
        rules: {
          excleCode: [
            { required: true, message: "请输入订单编号", trigger: "blur" },
          ],
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          scheduleDate: [
            { required: true, message: "请选择计划下达日期", trigger: "change" },
          ],
          serial: [{ required: true, message: "请输入序号", trigger: "blur" }],
          prepared: [
            { required: true, message: "请输入编制人", trigger: "blur" },
          ],
          approver: [
            { required: true, message: "请输入批准人", trigger: "blur" },
          ],
          examined: [
            { required: true, message: "请输入审批人", trigger: "blur" },
          ],
        },
        pickerOptions: {},
      };
    },
    mounted() {
      this.getAllClass()
      this.getUnit()
    },
    methods: {
      handleDeliveryChange(value) {
        // 当日期改变时触发验证或者其它逻辑
        this.$forceUpdate(); // 强制更新视图
      },

      // 如果需要在整个表单区域点击空白处刷新显示，可以添加：
      handleClickOutside() {
        this.$forceUpdate();
      },
      getUnit() {
        selectAllUnit().then(res => {
          this.unitList = res.data
        })
      },
      getItemRules(index, field) {
        if (field === "classIdAttr") {
          return [
            { required: true, message: "请选择产品类型", trigger: "change" },
          ];
        }
        else if (field === "num") {
          return [{ required: true, message: "请输入数量", trigger: "blur" }];
        }
        return [];
      },
      close() {
        this.$refs.elForm.resetFields();
        this.ruleForm.accessories = [
          {
            homecode: "",
            name: "",
            partNumber: "",
            drawing: "",
            num: "",
            unit: "",
            orderCompany: "",
            contract: "",
            delivery: "",
            remark: "",
            invoicing: "",
            sale: "",
            supplier_name: "",
            quantities: "",
            mold: 0,
          },
        ];
        this.dialogVisible = false;
      },
      open() {
        this.dialogVisible = true;
      },
      addItem() {
        this.ruleForm.accessories.push({
          homecode: "",
          name: "",
          partNumber: "",
          drawing: "",
          num: "",
          unit: "",
          orderCompany: "",
          contract: "",
          delivery: "",
          remark: "",
          invoicing: "",
          sale: "",
          supplier_name: "",
          quantities: "",
          mold: 0,
        });
      },
      deleteItem(index) {
        this.ruleForm.accessories.splice(index, 1);
      },
      getAllClass() {
        fetchClassTree({ type: 0, level: 0 }).then((res) => {
          this.mainProducts = res.data;
        });
      },
      selectItem(selectedValues, index) {

        let length = selectedValues.length;
        let selectedItem = this.findItemById(
          this.mainProducts,
          selectedValues[length - 1]
        );
        if (selectedItem) {
          this.ruleForm.accessories[index].partNumber = selectedItem.partNumber;
          this.ruleForm.accessories[index].name = selectedItem.name;
          this.ruleForm.accessories[index].classId = selectedItem.id;
          this.ruleForm.accessories[index].mold = length - 1;
        }
      },
      findItemById(items, id) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
          if (items[i].children) {
            let found = this.findItemById(items[i].children, id);
            if (found) {
              return found;
            }
          }
        }
        return null;
      },
      confirm() {
        this.$refs.elForm.validate((valid) => {
          if (valid) {
            console.log(this.ruleForm);
            let params = {
              ...this.ruleForm,
            };
            addBoomApi(params).then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.$emit("success");
                this.close();
              }
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .line {
    width: 90%;
    height: 1px;
    background: #dcdfe6;
    margin-left: 30px;
  }

  .mgb20 {
    margin-bottom: 20px;
  }

  .width80 {
    width: 85%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  .el-date-editor {
    width: 202px !important;
    margin: 0 !important;
  }

  .el-radio-group,
  .el-cascader {
    width: 202px !important;
  }
</style>